import type { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  card: {
    background: theme.color.surface,
    border: `1px solid ${theme.color.border}`,
    borderRadius: theme.radius,
    boxShadow: theme.shadow,
    padding: 20,
    minWidth: 0,
    [theme.narrow]: { padding: 16 },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 14,
  },
  title: { margin: 0, fontSize: 18 },
}));

interface CardProps {
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const Card = ({ title, actions, children }: CardProps) => {
  const classes = useStyles();
  return (
    <section className={classes.card}>
      {(title ?? actions) && (
        <div className={classes.header}>
          {title && <h2 className={classes.title}>{title}</h2>}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
};
